import Paperclip from '../../src/legacy/Paperclip.tsx';
export default Paperclip;
